export default function dupSlashRedirect({ route, redirect }) {
  if (route.fullPath.includes('//')) {
    const { path, query, hash } = route
    const nextPath = path.replace(/\/\//g, '/')
    const nextRoute = { path: nextPath, query, hash }
    redirect(nextRoute)
  }
}
